export const VideoDataTypes = ['video/mp4', 'video/ogg', 'video/webm'];
